// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DownloadRouteImport } from './routes/download'
import { Route as ClaimRouteImport } from './routes/claim'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DppIndexRouteImport } from './routes/dpp.index'
import { Route as DppIdRouteImport } from './routes/dpp.$id'

const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const DownloadRoute = DownloadRouteImport.update({
            id: '/download',path: '/download',getParentRoute: () => rootRouteImport
          })
const ClaimRoute = ClaimRouteImport.update({
            id: '/claim',path: '/claim',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const DppIndexRoute = DppIndexRouteImport.update({
            id: '/dpp/',path: '/dpp/',getParentRoute: () => rootRouteImport
          })
const DppIdRoute = DppIdRouteImport.update({
            id: '/dpp/$id',path: '/dpp/$id',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AccountRoute: AccountRoute,ClaimRoute: ClaimRoute,DownloadRoute: DownloadRoute,LoginRoute: LoginRoute,RegisterRoute: RegisterRoute,DppIdRoute: DppIdRoute,DppIndexRoute: DppIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)